export enum PagesQueryKeys {
  GetAll = 'pages/getAll',
  GetOneById = 'pages/getOneById',
  GetOneByIdDossier = 'pages/getOneByIdDossier',
  GetPageCriticalCss = 'pages/getPageCriticalCss',
  Create = 'pages/create',
  Edit = 'pages/edit',
  Delete = 'pages/delete',
  Breadcrumb = 'pages/breadcrumb',
  SearchAndReplace = 'pages/searchAndReplace',
  AutocompleteSearchAndReplace = 'pages/autocomplete/searchAndReplace',
  SearchAndReplaceHistory = 'pages/searchAndReplace/history',
  SearchAndReplaceHistoryRollback = 'pages/searchAndReplace/history/rollback',
  PagesCriticalCssSettings = 'pages/pagesCriticalCssSettings',
  PagesCriticalCssStyleFiles = 'pages/pagesCriticalCssStyleFiles',
  PagesCriticalCssGenerate = 'pages/pagesCriticalCssGenerate',
  EditPageCriticalCss = 'pages/editPageCriticalCss',
  PagesCriticalCssGenerationSummary = 'pages/pagesCriticalCssGenerationSummary',
  BulkPublish = 'pages/bulkPublish',
  BulkPublishList = 'pages/bulkPublish/list',
}

export enum PageNodesQueryKeys {
  Autocomplete = 'pageNodes/autocomplete',
  Create = 'pageNodes/create',
  Delete = 'pageNodes/delete',
  GetOneById = 'pageNodes/getOneById',
  Edit = 'pageNodes/edit',
  Breadcrumb = 'pageNodes/breadcrumb',
}

export enum PageComponentsQueryKeys {
  GetAll = 'pageComponents/getAll',
  GetOneById = 'pageComponents/getOneById',
  Create = 'pageComponents/create',
  Delete = 'pageComponents/delete',
  Edit = 'pageComponents/edit',
  Breadcrumb = 'pageComponents/breadcrumb',
  Autocomplete = 'pageComponents/autocomplete',
}
export enum PageLayoutsQueryKeys {
  GetAll = 'pageLayouts/getAll',
  GetOneById = 'pageLayouts/getOneById',
  Create = 'pageLayouts/create',
  Delete = 'pageLayouts/delete',
  Edit = 'pageLayouts/edit',
  Breadcrumb = 'pageLayouts/breadcrumb',
  Autocomplete = 'pageLayouts/autocomplete',
}
